import React, { useEffect, useRef } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeNotification } from "../../redux/notificationSlice";
import { NOTIFICATION_DISPLAY_MS } from "../../constants/notificationConstants";

function stripHtml(html) {
  if (!html || typeof html !== "string") return "";
  return html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
}

function getNotificationText(type, item) {
  const title =
    type === "mail"
      ? item?.subject || "Nieuw bericht"
      : item?.title || "Melding";

  const message =
    type === "mail"
      ? stripHtml(item?.body)?.slice(0, 120) ||
        (item?.sender
          ? `Van: ${item.sender}`
          : item?.author
            ? `Van: ${item.author}`
            : "Je hebt een nieuw bericht ontvangen.")
      : item?.message || item?.body || "";

  return { title, message };
}

const Notifications = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const items = useSelector((state) => state.notification.items);
  const shown = useRef(new Set());

  useEffect(() => {
    items.forEach((entry) => {
      if (shown.current.has(entry.id)) return;
      shown.current.add(entry.id);

      const { title, message } = getNotificationText(entry.type, entry.item);

      toast(
        (t) => (
          <div className="max-w-sm">
            <p className="text-sm font-semibold">{title}</p>
            {message ? <p className="mt-1 text-xs opacity-80">{message}</p> : null}
            {entry.type === "mail" ? (
              <button
                type="button"
                className="mt-2 text-xs font-medium text-indigo-500"
                onClick={() => {
                  toast.dismiss(t.id);
                  navigate("/mailbox");
                }}
              >
                Open postvak
              </button>
            ) : null}
          </div>
        ),
        {
          id: `notif_${entry.id}`,
          duration: NOTIFICATION_DISPLAY_MS,
          onClose: () => {
            dispatch(removeNotification(entry.id));
            shown.current.delete(entry.id);
          },
        }
      );
    });
  }, [items, dispatch, navigate]);

  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: NOTIFICATION_DISPLAY_MS,
      }}
    />
  );
};

export default Notifications;
